module.exports = __webpack_public_path__ + "img/resbilan.8f8987c7.png";